import React from "react"
import { MDXProvider } from "@mdx-js/react"
import styled from "styled-components"
import { Link } from "gatsby"

import Footnote from "./footnote"
import StaticGraphic from "./static-graphic"
import AudioClip from "./audio-clip"
import Blockquote from "./blockquote"
import Caption from "./caption"
import TextHighlighter from "./text-highlighter"

// Replacements for standard HTML tags
const paragraphWrapper = styled.p`
    width: 100%;
    max-width: 48em;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0.5rem;

    @media screen and (min-width: 60em) {
        width: 60%;
    }

    @media screen and (min-width: 38em) {
        max-width: 96em;
        margin-left: 0;
        margin-right: 0;
        padding-right: 2rem;
        font-size: 1.5rem;
        line-height: 2.1rem;
    }

    @media screen and (max-width: 38em) {
        font-size: 1.3rem;
        line-height: 1.7rem;
    }

    &:first-of-type::first-letter {
        font-weight: bold;
        font-size: 2.4rem;
        color: #ed6a5a;
    }
`

const ulWrapper = styled.ul`
    width: 100%;
    max-width: 48em;
    margin-left: auto;
    margin-right: auto;
    padding-right: 2rem;

    @media screen and (min-width: 60em) {
        width: 60%;
    }
    @media screen and (min-width: 30em) {
        max-width: 96em;
        margin-left: 0;
        margin-right: 0;
    }
`

const preWrapper = styled.pre`
    overflow: auto;
    margin-left: 0;
    width: 80%;
    max-width: 48em;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    border-left-style: solid;
    border-left-width: 1px;
    border-width: 0.25rem;
    border-color: #137752;

    @media screen and (min-width: 60em) {
        width: 50%;
    }
`

const h2Wrapper = styled.h2`
    display: inline-block;
`

const VideoWrapperOuter = styled.div`
    width: 100%
    align-items: center;
    margin-top: 2rem;
    @media screen and (min-width: 60em) {
        display: flex;
    padding-bottom: 2rem;
    }
`

const VideoWrapper = styled.div`
    width: 100%;
    @media screen and (min-width: 60em) {
        width: 60%;
    }
    @media screen and (min-width: 30em) {
        padding-right: 2rem;
    }
`

const EntryLink = (props) => {
    if (props.href) {
        return <Link to={props.href}>{props.children}</Link>
    } else if (props.name) {
        return <a name={props.name} />
    }
}

const AtlasMDXProvider = ({ children }) => {
    return (
        <MDXProvider
            components={{
                a: EntryLink,
                p: paragraphWrapper,
                ul: ulWrapper,
                pre: preWrapper,
                h2: h2Wrapper,
                VideoWrapperOuter: VideoWrapperOuter,
                VideoWrapper: VideoWrapper,
                Link: (props) => <Link {...props} />,
                Footnote: (props) => <Footnote {...props} />,
                StaticGraphic: (props) => <StaticGraphic {...props} />,
                AudioClip: (props) => <AudioClip {...props} />,
                Blockquote: (props) => <Blockquote {...props} />,
                Caption: (props) => <Caption {...props} />,
                TextHighlighter: (props) => <TextHighlighter {...props} />,
                // IncludeGraphic: (props) => <IncludeGraphic {...props} />,
            }}
        >
            {children}
        </MDXProvider>
    )
}

export default AtlasMDXProvider
